export default __webpack_public_path__ + "static/media/about-gallery3.77d15ca5.jpg";